export default __webpack_public_path__ + "static/media/landing__page__ecomm__image.8ec36412.png";